// Copyright (c) 2016 Deere & Company

import PlanNames, {getDefaultState} from '../state/plan-names';
import actions from '../../actions-list';

const updatePlanNames = (state, action) =>
    PlanNames.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_MAINTENANCE_PLAN_PLAN_NAMES_SUCCESS]: updatePlanNames
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/reducers/plan-names.js